import { client } from "../api/axios";  
import { ChatSendMessage, ChatMessageDto, CanUserSendMessage, UnresolvedCount, ChatId } from "../types/ChatMessage";

const JSON_HEADERS = {
  "Content-Type": "application/json",
  Accept: "application/json",
};

interface ChatApi {
    sendMessage: (chatMessage: ChatSendMessage) => Promise<void>;
    getMessages: (chatId: string, limit: number, skip: number) => Promise<ChatMessageDto[]>;
    canUserSendMessage: () => Promise<CanUserSendMessage>;
    getAvailableQuestionsCount: (chatId: string) => Promise<UnresolvedCount>;
    getChatIdByUserId: () => Promise<ChatId>;
}
 const chatApi: ChatApi = {
  sendMessage: async (chatMessage: ChatSendMessage): Promise<void> => {
      const response = await client.post("/sendMessage", chatMessage, {
      headers: JSON_HEADERS,
    });
    return response.data;
  },

  getMessages: async (
    chatId: string,
    limit: number = 20,
    skip: number = 0
  ): Promise<ChatMessageDto[]> => {
    const response = await client.get(
      `/getMessages?chatId=${chatId}&limit=${limit}&skip=${skip}`,
      { headers: JSON_HEADERS }
    );
    return response.data;
  },

  canUserSendMessage: async (): Promise<CanUserSendMessage> => {
    const response = await client.get<CanUserSendMessage>(`/getUnresolvedQuestionStatusByUserId`);
    return response.data;
  },
  getAvailableQuestionsCount: async (chatId: string): Promise<UnresolvedCount> => {
    const response = await client.get<UnresolvedCount>(`/getUnresolvedQuestionCountByChatId?chatId=${chatId}`);
    return response.data;
  },

  getChatIdByUserId: async (): Promise<ChatId> => {
    const response = await client.get<ChatId>(`/getChatIdByUserId`);
    return response.data;
  },

};

export default chatApi;
export type { ChatMessageDto };
